export const comunicationsSteps = [
	{
		id: "engagement",
		label: "Engajamento",
		size: 6,
		className: "breadcrumb",
		step: true
	},
	{
		id: "comunications",
		label: "Comunicação",
		size: 6,
		className: "breadcrumb",
		step: true
	}
];


// WEBPACK FOOTER //
// src/models/lib/tabs/comunicationsSteps.js